import { useContext } from "react";

import { FormBoundaryContext } from "./_context";

export const useFormBoundary = (): undefined | string => useContext(FormBoundaryContext);
